import {fadeIn, fadeOut} from '../helpers/animation';

export default class ToggleNav {

	constructor( element, trigger, target ) {
		this.element = element;
		this.triggers = trigger;
		this.target = target;

		this.triggers.forEach( trigger => {
			trigger.style.cursor = 'pointer';
		} );

		this.initEvents();
	}

	isActive() {
		return this.element.classList.contains( 'active' );
	}

	toggle() {

		if ( this.isActive() ) {
			this.element.classList.remove( 'active' );
			fadeOut( this.target, 100 );
		} else {
			this.element.classList.add( 'active' );
			fadeIn( this.target, 500 );
		}
	}

	initEvents() {
		this.triggers.forEach( trigger => {
			trigger.addEventListener( 'click', ( e ) => {
				e.preventDefault();
				this.toggle();
			} );
		} )

	}

}